import brandedTerms from './brandedTerms'
import susieCakes from './susieCakes'
import thanx from './thanx'

export default {
  thanx,
  brandedTerms,
  susieCakes,
}
